import { ChevronDownOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronDownOutlined";
import { ProductCardLayoutProps } from "../../types/types";
import { Slot } from "../ProductCardSlot";
import styles from "./List.module.scss";
import classNames from "classnames/bind";
import { sendMonetateEvent } from "@~/utils/sendMonetateEvent";

const cx = classNames.bind(styles);

export const slotNameMap = {
  IMAGE_BANNER: "image-banner",
  IMAGE: "image",
  HEADER: "header",
  DETAILS_PRIMARY: "details-primary",
  DETAILS_SECONDARY: "details-secondary",
  IMAGE_ACTIONS: "image-actions",
  IMAGE_FOOTER: "image-footer",
  HEADER_ACTIONS: "header-actions",
  ASIDE: "aside",
  FOOTER: "footer",
};

export const List = ({ config, product, index }: ProductCardLayoutProps) => {
  return (
    <article
      onClick={() => {
        sendMonetateEvent("productCard.interaction");
      }}
      className={styles["card-container"]}
      data-product-card-layout="List"
      data-testid="product-card-layout"
      data-product-id={product?.aliases?.pimProductId}
      id={product?.aliases?.pimProductId} // Needed for wish list scrolling
    >
      <div className={styles["inner-container"]}>
        <div className={styles["left-column"]}>
          <div className={styles["image-container"]}>
            <Slot
              slotName={slotNameMap["IMAGE_BANNER"]}
              className={styles["image-banner-slot"]}
              config={config}
              product={product}
              index={index}
            />
            <Slot
              slotName={slotNameMap["IMAGE"]}
              className={styles["image-slot"]}
              config={config}
              product={product}
              index={index}
            />
            <Slot
              slotName={slotNameMap["IMAGE_ACTIONS"]}
              className={styles["image-actions-slot"]}
              config={config}
              product={product}
              index={index}
            />
          </div>
          <Slot
            slotName={slotNameMap["IMAGE_FOOTER"]}
            className={styles["image-footer-slot"]}
            config={config}
            product={product}
            index={index}
          />
        </div>

        <div className={styles["header-container"]}>
          <Slot
            slotName={slotNameMap["HEADER"]}
            className={styles["header-slot"]}
            config={config}
            product={product}
            index={index}
          />
          <Slot
            slotName={slotNameMap["HEADER_ACTIONS"]}
            className={styles["header-actions-slot"]}
            config={config}
            product={product}
            index={index}
          />
        </div>

        <Slot
          slotName={slotNameMap["ASIDE"]}
          className={styles["aside-slot"]}
          config={config}
          product={product}
          index={index}
        />

        <div className={styles["details-container"]}>
          <div className={styles["details-accordion"]}>
            <button
              data-testid="details-accordion-button"
              aria-expanded={index === 0 ? "true" : "false"}
              aria-controls={`details-accordion-${product?.aliases?.pimProductId}`}
              type="button"
              className={styles["details-accordion-button"]}
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                const button = event.currentTarget;
                button.setAttribute(
                  "aria-expanded",
                  button.getAttribute("aria-expanded") === "true"
                    ? "false"
                    : "true",
                );
              }}
            >
              Key specifications:
              <ChevronDownOutlined
                className={styles["details-accordion-icon"]}
                size="medium"
              />
            </button>
            <Slot
              slotName={slotNameMap["DETAILS_PRIMARY"]}
              id={`details-accordion-${product?.aliases?.pimProductId}`}
              className={cx("details-primary-slot", "details-accordion-panel")}
              config={config}
              product={product}
              index={index}
            />
          </div>
          <Slot
            slotName={slotNameMap["DETAILS_SECONDARY"]}
            className={cx("details-secondary-slot")}
            config={config}
            product={product}
            index={index}
          />
        </div>
        <Slot
          slotName={slotNameMap["FOOTER"]}
          className={styles["footer-slot"]}
          config={config}
          product={product}
          index={index}
        />
      </div>
    </article>
  );
};
